import { gql } from "@apollo/client";

export const GET_PACIENTE_PROBABLE_BY_ID = gql`
query GetPrePacienteById(
    $prepacienteId: Int!
) {
    prePacienteById(
        prePacienteId: $prepacienteId
    )
    {
        idDelegacion
        codInstitucion
        nombre
        apellido
        sexo
        edad
        fechaNacimiento
        idTipoDocumento
        nroDocumento
        telPaciente
        telFamiliar
        nombreFamiliar
        observacion
        idPrescripcionPacienteNavigation {
            id
            titulo
            contentType
            imagenPerfil
            imagenExtension
        }
        idEstado
        idPrePaciente
        fechaAlta
        fechaAltaProbable
        fechaModificacion
        fechaAltaProbable
        financiador
        referente
        idTipoModulo
        codInstitucionNavigation {
            nombre
        }
        idDelegacionNavigation {
            descripcion
        }
        idTipoDocumentoNavigation {
            idTipoDocumento
            descripcion
        }
    }
}`;